import React, { useEffect, useState } from 'react';
import {
  Dropdown,
  DropdownOverlay,
  AutoComplete,
  ActionList,
  ActionListItem,
  Box,
  Spinner,
  Text,
  AutoCompleteProps,
} from '@razorpay/blade/components';
import { useQuery } from 'react-query';
import api from 'api';
import { getStateName } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/utils';
import { officeLocationQueryKeys } from 'components/OfficeLocation/PreviewOfficeLocations/data';

export const OfficeLocationDropdown = ({
  value,
  onChange,
}: {
  value: string;
  onChange: AutoCompleteProps['onChange'];
}) => {
  const [searchValue, setSearchValue] = useState(value);

  const { data, isLoading, isFetching } = useQuery({
    queryKey: [officeLocationQueryKeys.GET_OFFICE_LOCATIONS],
    queryFn: () =>
      api.officeLocation.fetchOfficeLocations({
        page: 1,
        limit: 100,
      }),
  });

  const officeLocations = data?.data || [];

  const filteredOfficeLocations =
    officeLocations?.filter(({ office_name: name }) =>
      searchValue ? name.toLowerCase().includes(searchValue.toLowerCase()) : true,
    ) || [];

  const selectedOfficeLocationName = officeLocations?.find(
    ({ id }) => id === Number(value),
  )?.office_name;

  useEffect(() => {
    if (selectedOfficeLocationName) {
      setSearchValue(selectedOfficeLocationName || '');
    }
  }, [selectedOfficeLocationName]);

  return (
    <Dropdown
      selectionType="single"
      onOpenChange={(isOpen) => {
        if (!isOpen && selectedOfficeLocationName) {
          setSearchValue(selectedOfficeLocationName);
        } else {
          setSearchValue('');
        }
      }}>
      <AutoComplete
        label=""
        placeholder="Select"
        inputValue={searchValue || ''}
        onInputValueChange={({ value }) => {
          setSearchValue(value || '');
        }}
        filteredValues={filteredOfficeLocations.map(({ id }) => id.toString())}
        value={value}
        onChange={onChange}
      />
      <DropdownOverlay>
        {isLoading || isFetching ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap="spacing.5"
            padding="spacing.5">
            <Spinner accessibilityLabel="loading states" />
          </Box>
        ) : filteredOfficeLocations?.length ? (
          <ActionList>
            {filteredOfficeLocations?.map((officeLocation) => (
              <ActionListItem
                key={officeLocation.id}
                title={officeLocation.office_name}
                value={officeLocation.id.toString()}
                isSelected={value === officeLocation.id.toString()}
                description={getStateName(officeLocation.state)}
              />
            ))}
          </ActionList>
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="spacing.5"
            padding="spacing.5">
            <Box display="flex" flexDirection="column" gap="spacing.3">
              <Text size="large" weight="semibold" textAlign="center">
                No Office Locations Found
              </Text>
            </Box>
          </Box>
        )}
      </DropdownOverlay>
    </Dropdown>
  );
};
